import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from "react-router-dom";
import { MessagePanelElement, IconError, IconSuccess, Message } from './style';
import { MESSAGE_TYPE } from '../../../utils/constants'

export const MessagePanel = (props) => {
    const { t } = useTranslation();
    const [countdown, setCountdown] = useState(5);
    const [searchParams] = useSearchParams();
    const errorUrl = searchParams.get("errorUrl");

    useEffect(() => {
        if (errorUrl || props.redirectUrl) {
            if (props.instantRedirect) {
                redirect();
                return;
            } 
           
            const timeId = setTimeout(redirect, 5000);
            return () => { clearTimeout(timeId); }
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prevCounter) => prevCounter - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const redirect = () => {
        window.location.href = props.redirectUrl || errorUrl;
    }

    return (
        <div>
            {(!props.instantRedirect) &&
                <MessagePanelElement className="dx-theme-material-typography">
                    {(!props.type || props.type === MESSAGE_TYPE.ERROR || props.type === MESSAGE_TYPE.CANCELED) &&
                        <IconError>
                            <div className="circle1">
                                <div className="circle2">
                                    <div className="circle3"></div>
                                </div>
                            </div>
                        </IconError>
                    }

                    {(props.type && props.type === MESSAGE_TYPE.SUCCESS) &&
                        <IconSuccess>
                            <div className="circle1">
                                <div className="circle2">
                                    <div className="circle3"></div>
                                </div>
                            </div>
                        </IconSuccess>
                    }

                    <Message>{t(`MESSAGE_LABELS.${props.message}`)}</Message>

                    {errorUrl && <Message> {t('MESSAGE_LABELS.REDIRECT_COUNTDOWN', { countdown: countdown })}</Message>}
                </MessagePanelElement>
            }
        </div>
    );
}
